import React from 'react';
import { Stack, Typography } from '@mui/material';

// Left-aligned section heading: primary-coloured icon + h5 title.
const SectionHeading = ({ icon: Icon, children }) => (
    <Stack direction="row" spacing={1.25} sx={{ mb: 2.5, alignItems: 'center' }}>
        {Icon && <Icon sx={{ color: 'primary.main', fontSize: 28, flexShrink: 0 }} />}
        <Typography variant="h5" component="h2">
            {children}
        </Typography>
    </Stack>
);

export default SectionHeading;
